module.exports = __webpack_public_path__ + "img/gear-G-high_98x98.fccd0237.png";